import _parseInt from 'lodash/parseInt';
import APPCONFIG from '../../../constants/Config';
import {
  CPM_LIST_WORKSPACE_GROUPS,
  CPM_CREATE_WORKSPACE_GROUP,
  CPM_UPDATE_WORKSPACE_GROUP,
} from '../../../constants/ActionTypes';
/* eslint-disable import/named */
import { deserialize } from '../../../models/cpm/workspaceGroup';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmWorkspaceGroup;
const cpmWorkspace = (state = initialSettings, action) => {
  switch (action.type) {
    // CPM_LIST_WORKSPACE_GROUPS
    case CPM_LIST_WORKSPACE_GROUPS:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case `${CPM_LIST_WORKSPACE_GROUPS}_ERROR`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.error,
        },
      };
    case `${CPM_LIST_WORKSPACE_GROUPS}_SUCCESS`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            data: deserialize(action.data.listWorkspaceGroups.entries),
            pageNumber: _parseInt(action.data.listWorkspaceGroups.pageNumber),
            pageSize: _parseInt(action.data.listWorkspaceGroups.pageSize),
            totalEntries: _parseInt(
              action.data.listWorkspaceGroups.totalEntries,
            ),
            totalPages: _parseInt(action.data.listWorkspaceGroups.totalPages),
          },
        },
      };
    // CPM_CREATE_WORKSPACE_GROUP
    case CPM_CREATE_WORKSPACE_GROUP:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: null,
        },
      };
    case `${CPM_CREATE_WORKSPACE_GROUP}_ERROR`:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case `${CPM_CREATE_WORKSPACE_GROUP}_SUCCESS`:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
        },
      };
    // CPM_UPDATE_WORKSPACE_GROUP
    case CPM_UPDATE_WORKSPACE_GROUP:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
        },
      };
    case `${CPM_UPDATE_WORKSPACE_GROUP}_ERROR`:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case `${CPM_UPDATE_WORKSPACE_GROUP}_SUCCESS`:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
        },
      };
    default:
      return state;
  }
};

export default cpmWorkspace;



// WEBPACK FOOTER //
// ./reducers/cpm/workspace/workspaceGroup.js